import React from "react";
import { Button } from "@/components/ui/button";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";
import { Droplet } from "lucide-react";
import { ShadowMode } from "../types";

export interface ShadowModeSelectorProps {
  shadowMode: ShadowMode;
  onShadowModeChange: (mode: ShadowMode) => void;
}

const SHADOW_OPTIONS: { value: ShadowMode; label: string }[] = [
  { value: 'folder', label: 'Folder' },
  { value: 'status', label: 'Status' },
  { value: 'template', label: 'Template' },
  { value: 'black', label: 'Black' },
  { value: 'none', label: 'None' }
];

/**
 * Shadow mode selector component.
 * Provides a dropdown to select the shadow display mode.
 */
export function ShadowModeSelector({
  shadowMode,
  onShadowModeChange,
}: ShadowModeSelectorProps) {
  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button
          variant="ghost"
          size="sm"
          className="p-2 text-muted-foreground hover:text-foreground hover:bg-muted"
          title="Shadow Mode"
        >
          <Droplet className="h-4 w-4" />
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-40 p-2" align="start">
        <div className="space-y-1">
          <div className="px-2 py-1.5 text-xs font-medium text-muted-foreground">
            Shadow Mode
          </div>
          {SHADOW_OPTIONS.map((option) => (
            <Button
              key={option.value}
              variant="ghost"
              size="sm"
              className={`w-full justify-start text-sm ${
                shadowMode === option.value
                  ? 'bg-muted text-foreground font-medium'
                  : 'hover:bg-muted'
              }`}
              onClick={() => onShadowModeChange(option.value)}
            >
              {option.label}
            </Button>
          ))}
        </div>
      </PopoverContent>
    </Popover>
  );
}

export default ShadowModeSelector;

